import React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Loader, ErrorFallback } from 'smart-react';
import ProductList from '../../Core/ProductList/UserOrganizationProduct/ProductList';
import { getPersonalTenant } from '../../../Utils/Auth/ValidatePermissions';
/**
 * Products main screen
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Products component.
 */
const Products = () => {
  const personalTenant = getPersonalTenant();

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className='tw-container flex w-full flex-col gap-5 py-5 text-[13px] text-foreground sm:py-6 [&_a]:cursor-pointer [&_button]:cursor-pointer'>
        <div className='xmb-5'>
          <h1 className='!text-[28px] !leading-none font-semibold !tracking-[-0.03em] text-foreground'>
            Products
          </h1>
        </div>
        <React.Suspense fallback={<Loader />}>
          <ProductList
            isOrganizationProduct={false}
            tenantID={personalTenant?.TenantId}
            subscribed={false}
          />
        </React.Suspense>
      </div>
    </ErrorBoundary>
  );
};
export default Products;
